import ThinCreditFile from './ThinCreditFile';

export default ThinCreditFile;
